import MapScale from '@/Enums/Map/MapScale.enum';
import ReportProperty from '@/Enums/Report/BeeswaxReportProperties.enum';
import AdswizzReportView from '@/Enums/ReportingDashboard/ReportView/AdswizzReportView.enum';
import ReportView from '@/Enums/ReportingDashboard/ReportView/ReportView.enum';
import type { ITotalReportRecord } from '@/Interfaces/ReportingDashboard/Adswizz/ReportRecord.interface';
import type { AdswizzMapScale, AdswizzReportingView } from '@/types/ReportingDashboard/Adswizz.types';

export const adswizzMapScales: Array<Exclude<MapScale, MapScale.City>> = Object.values(MapScale).filter(
  view => view !== MapScale.City,
) as Array<Exclude<MapScale, MapScale.City>>;

export const adswizzReportTypes: Array<Exclude<AdswizzReportingView, AdswizzMapScale>> = [
  ReportView.Date,
  ReportView.Device,
  ReportView.Advertiser,
  ReportView.Campaign,
  ReportView.Placement,
  ReportView.Creative,
  ReportView.Publisher,
  ReportView.DaysOfWeek,
  ReportView.Daypart,
  AdswizzReportView.Genre,
  ReportView.Deals,
];

export const adswizzImpressionTypes = adswizzReportTypes.map(view => ({ label: view, value: view }));

export const allowedAdswizzTablesToPrint: AdswizzReportingView[] = [...adswizzReportTypes, ...adswizzMapScales];

export const maxAdswizzReportingRecords = 100;

export const adswizzReportingTimezone = 'US/Eastern';

export const adswizzDefaultTotals: ITotalReportRecord = {
  [ReportProperty.IMPRESSIONS]: 0,
  [ReportProperty.REACH]: 0,
  [ReportProperty.FREQUENCY]: 0,
  [ReportProperty.VCR]: 0,
  [ReportProperty.LTR]: 0,
  [ReportProperty.CTR]: 0,
  [ReportProperty.CLICKS]: 0,
  [ReportProperty.IP_CONVERSIONS]: 0,
};
